import { useLocation } from 'react-router-dom';

export default function useQuery() {
  const location = useLocation();
  const sp = new URLSearchParams(location.search);

  return Object.fromEntries(sp);
}
